import script from "./side-bar-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./side-bar-item.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__